import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

const groupAdministrationValidator = /^(?=.*[A-Za-z])(?=.*\d)\S+$/;

export function groupAdministrationFormatValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;

    if (value === null || value === undefined || value === '') {
      return null;
    }

    return groupAdministrationValidator.test(String(value)) ? null : { groupAdministrationFormat: true };
  };
}
